'use client';
import { TagsGroup } from '@fe-common-ui/Group';
import List, { AsideNewsGtmEventType } from '@fe-common-ui/List';
import Skeleton from '@fe-common-ui/LoadingSkeleton';
import { postTimeDisplayFactory } from '@fe-common-utils/libs/time';
import CollectionSaveButton from '@fe-news/components/atoms/CollectionSaveButton';
import { MOBILE_NEWS_LIST_TITLE } from '@fe-news/constants/size/font';
import { styled } from '@linaria/react';

export const CARD_HEIGHT = 154;

type NewsCardProps = {
  index: number;
  data: ListNewsItem[];
  style: React.CSSProperties;
};

const EmptyContainer = styled.div`
  margin-bottom: 16px;
`;

const TagContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

// Mobile新聞列表卡片
const IndexListCard = ({ index, data, style }: NewsCardProps) => {
  if (!data || !data[index]) {
    return (
      <EmptyContainer style={style}>
        <Skeleton.NewsSkeleton />
      </EmptyContainer>
    );
  }

  const { title, newsId, publishAt, categoryName, coverSrc, keyword, quotes } = data[index];
  const imgSource = coverSrc?.m?.src;
  const time = postTimeDisplayFactory(publishAt * 1000)?.display ?? '--';

  return (
    <div key={newsId} style={style} className='mobile-index-list-item'>
      <List.AsideNews
        key={`${newsId}-${index}`}
        newsId={newsId}
        publishAt={time}
        title={title}
        coverSrc={imgSource}
        fontSize={MOBILE_NEWS_LIST_TITLE}
        lineHeight={1.5}
        categoryName={categoryName}
        coverWidth={85}
        coverHeight={60}
        url={`/news/id/${newsId}`}
        Tags={
          <TagContainer>
            <TagsGroup tags={keyword} otherProduct={quotes} />
            <CollectionSaveButton newsId={newsId} />
          </TagContainer>
        }
        gtmEventType={AsideNewsGtmEventType.NEWS_LIST}
      />
    </div>
  );
};

export default IndexListCard;
